import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
`;
